import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n/i18n';

// Удаляем импорт мок-сервера
// import { startMockServer } from './mocks/browser';

// Удаляем запуск мок-сервера
// if (process.env.NODE_ENV === 'development') {
//   startMockServer();
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 